import EmployerEdit from "../Edits/EmployerEdit";
import CmModal from "../Controls/CmModal";

export default function EmployerEditModal({ employerId = 0, promptForAdmin = false, onClose }) {
  const id = Number.parseInt(employerId, 10) || 0;
  const title = id > 0 ? "Employer" : "Add Employer";

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="wide"
      testId="employer-edit-modal"
    >
      <EmployerEdit
        employerId={id}
        promptForAdmin={promptForAdmin}
        onClose={onClose}
      />
    </CmModal>
  );
}
